import { render } from "./editlog-overview.vue?vue&type=template&id=bd254d20"
import script from "./editlog-overview.vue?vue&type=script&lang=js"
export * from "./editlog-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__